export const QUERY_SHARED_FILE_SETTINGS = "QUERY_SHARED_FILE_SETTINGS";
export const QUERY_SHARED_FILE = "QUERY_SHARED_FILE";
